export const NUMBER_KEYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

export const NUMBER_COLORS = [
  "#FFB300",
  "#803E75",
  "#FF6800",
  "#A6BDD7",
  "#C10020",
  "#CEA262",
  "#817066",
  "#007D34",
  "#F6768E",
  "#00538A",
];

export const NOOP = "Noop";
